import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { CommonService } from "@app/core";
import { Observable } from "rxjs";


@Injectable({ providedIn: 'root' })

export class WorkflowResolver  {
    constructor(
        private readonly _commonService: CommonService,
        private readonly _router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {

        const appData = this._commonService.appProfileDataAsValue;

        if (!appData?.currentOrganization?.workflow_enabled) {
            this._router.navigate(
                [route?.queryParams?.returnTo?.length ? route?.queryParams?.returnTo : '/home']
            );
            return false;
        }

        return true;

    }
}